export const VERSION_ID = 50300;

export const PLATFORM = "vamoos_web";

export const VERIFICATION_CODE_LENGTH = 6;

export const VAMOOS_URL = "https://www.vamoos.com/";

export const DOC_ID_INDEX_FROM_END = 3; // because the doc id is always placed on third place from the end :docId/gallery/:slideNum

export const EWA_STORAGE_LIMIT_BYTES = 1_000_000; // 1Mb

export const EWA_CSS_VARIABLE_NAMES = [
  '--accent-color',
  '--input-field-background-color',
  '--input-field-frame-color',
  '--input-text-color',
  '--input-input-hint-color',
  '--button-text-color-active',
  '--button-background-color-active',
  '--button-text-color-inactive',
  '--button-background-color-inactive',
];

export const BACK_NAVIGATION_TYPE = "back"